/** @format */

import angular from 'angular';

import { GbDraggableDirective } from './gb-draggable/gb-draggable.directive.js';
import { GbDragHandleDirective } from './gb-drag-handle/gb-drag-handle.directive.js';

export const DirectivesModule = angular
    .module('galabid-presenter.shared.directives', [])
    .directive('gbDraggable', GbDraggableDirective)
    .directive('gbDragHandle', GbDragHandleDirective).name;
